import React, {useCallback, useEffect, useState, useRef} from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  FlatList,
  Dimensions,
} from 'react-native';

import RenderHtml from 'react-native-render-html';
import {Color, globalFontStyle} from '../../assets';
import {timeLagFromCurrentTime} from '../../utils/commonMethods';
import Colors from '../../assets/Color/Colors';
import {globalConfigurableData} from '../../utils/globalConstant';

const abc = {
  'live-data-details-row': {
    display: 'flex',
    padding: '5px 0px',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  'event-heading-style': {
    padding: '10px 0px 10px 0px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomWidth: 0.75,
    borderColor: '#CDCDCD',
  },
  'app-font-sub-heading': {
    fontFamily: 'Inter',
    fontSize: '15px',
    fontWeight: '600',
  },
  'app-font-sub-text': {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: '400',
  },
  'app-red-error': {
    color: '#e90000',
  },
  'app-font-body': {
    fontFamily: 'Inter',
    fontSize: '15px',
    fontWeight: '400',
  },
  'app-grey': {
    color: globalConfigurableData.primaryTextColor,
  },
  'app-font-sub-text-bold': {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: '700',
  },
  'app-black': {
    color: globalConfigurableData.primaryTextColor,
  },
  'app-font-small-text': {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '400',
  },
  'app-light-grey': {
    color: globalConfigurableData.primaryTextColor,
  },
};

const RenderHtmlScore = ({liveDataNew, liveDataTime}) => {
  return (
    <View style={{}}>
      <RenderHtml
        contentWidth={Dimensions.get('window').width}
        source={{html: liveDataNew}}
        tagsStyles={{p: {margin: 0}}}
        classesStyles={abc}
      />
    </View>
  );
};

export default React.memo(RenderHtmlScore);
